/* eslint-disable react/react-in-jsx-scope */
import { Grid, Typography } from "@material-ui/core";
import useText from "constants/text";
import { useCourseContext } from "contexts/CourseContext";
import { ICourseModal, Iproduct } from "domains/Course/data/types";
import { DeleteProduct, mondalButtonsStyle, useAddProductStyle } from "domains/Course/style";
import { DeletionIcon } from "icons";
import { memo, useState } from "react";
import Dialog from "ui/Dialog";
import { TextField } from "ui/TextField";
import { AddItem } from "../AddItem";

function AddProductModal({ open, onClose, itemIndex }: ICourseModal) {
  const [isSubmited, setIsSubmited] = useState(false);
  const classes = useAddProductStyle();
  const { text } = useText();
  const { pickups, addProductToPickup, deleteProductFromPickup, editPickup } = useCourseContext();

  const handleProductName = (productIndex: number) => (event: any) => {
    editPickup(itemIndex, event?.target?.name, event?.target?.value, productIndex);
  };
  const handleQuantity = (productIndex: number) => (event: any) => {
    editPickup(itemIndex, event?.target?.name, event?.target?.value, productIndex);
  };

  const isAllProductFieldValid = () => pickups[itemIndex]?.products.every((produc: Iproduct) => !!produc.name);

  const handleOnConfirm = () => {
    setIsSubmited(true);
    if (isAllProductFieldValid()) {
      onClose();
      setIsSubmited(false);
    }
  };

  const handleAddProduct = () => {
    addProductToPickup(itemIndex);
  };

  const handleDeleteProduc = (productIndex: number) => {
    deleteProductFromPickup(itemIndex, productIndex);
  };

  const isLastProductFieldEmpty = (): boolean =>
    !!pickups[itemIndex].products[pickups[itemIndex].products?.length - 1]?.name;

  const handleOnClose = () => {
    if (isLastProductFieldEmpty) {
      deleteProductFromPickup(itemIndex, pickups[itemIndex].products?.length - 1);
    }
    onClose();
    setIsSubmited(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        hideDialogHeader
        confirmButtonTitle={text.all.validate}
        cancelButtonTitle={text.all.cancel}
        handleClose={handleOnClose}
        confirmButtonStyle={mondalButtonsStyle}
        closeButtonStyle={mondalButtonsStyle}
        handleConfirm={handleOnConfirm}
      >
        <Typography className={classes.title}>{text.all.product_to_pick}</Typography>
        <Grid container spacing={3}>
          {pickups[itemIndex]?.products?.map((item: any, index: number) => (
            <>
              <Grid item container spacing={4}>
                <Grid item xs={7}>
                <TextField
                  required
                  variant="outlined"
                  label={text.course.product_pickup}
                  name="name"
                  fullWidth
                  placeholder={text.all.product_description}
                  value={item?.name}
                  onChange={handleProductName(index)}
                  error={isSubmited && !item?.name?.trim()}
                  helperText={isSubmited && !item?.name?.trim() ? text.all.this_field_is_required : ""}
                />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    required
                    variant="outlined"
                    label="quantity"
                    name="quantity"
                    fullWidth
                    placeholder={text.all.quantity}
                    value={item?.quantity}
                    onChange={handleQuantity(index)}
                    type="number"
                    InputProps={{ inputProps: { min: 1 } }}
                  />
                </Grid>
                {pickups[itemIndex]?.products?.length > 1 && (
                  <DeleteProduct onClick={() => handleDeleteProduc(index)}>
                    <DeletionIcon width={15} height={15} />
                  </DeleteProduct>
                )}
              </Grid>
            </>
          ))}
          <Grid item xs={12}>
            <AddItem title={text.course.add_product} onClick={handleAddProduct} />
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}

export default memo(AddProductModal);
